"use strict";
import { useCallback } from "react";
export const useScrollToElement = (containerRef, defaultOptions = {}) => {
  const {
    behavior = "smooth",
    offset = 0,
    selector = '[data-highlighted="true"]'
  } = defaultOptions;
  const scrollToBottom = useCallback(() => {
    window.requestAnimationFrame(() => {
      if (!containerRef.current) return;
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior
      });
    });
  }, [containerRef, behavior]);
  const scrollToElement = useCallback(
    (elementSelector, options = {}) => {
      window.requestAnimationFrame(() => {
        if (!containerRef.current) return;
        const elements = containerRef.current.querySelectorAll(elementSelector);
        if (elements.length > 0) {
          const firstElement = elements[0];
          const containerTop = containerRef.current.getBoundingClientRect().top;
          const elementTop = firstElement.getBoundingClientRect().top;
          const scrollOffset = elementTop - containerTop - (options.offset || offset);
          containerRef.current.scrollTo({
            top: containerRef.current.scrollTop + scrollOffset,
            behavior: options.behavior || behavior
          });
        } else {
          scrollToBottom();
        }
      });
    },
    [containerRef, behavior, offset, scrollToBottom]
  );
  const scrollToHighlighted = useCallback(
    (options = {}) => {
      scrollToElement(selector, options);
    },
    [scrollToElement, selector]
  );
  return {
    scrollToBottom,
    scrollToElement,
    scrollToHighlighted
  };
};
